import React from "react"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import { linkContainer, linksTitle } from "../styles/plan-site.module.scss"
import {
  StyledLink,
  StyledExternalLink,
} from "../styled-components/plan-site-styled"
import PropTypes from "prop-types"
import Ariane from "../components/Ariane/ariane"
import { useSitePage } from "../hooks/use-site-page"
import { getIncomingAndPublishedData } from "../components/get-incoming-and-published-data"

const normalize = (string) => {
  string = string
    .replace(/[^a-zA-Z ]/g, " ")
    .replace(/\w/, (char) => char.toUpperCase())
  return string
}

const PlanSite = ({ arianeDisplayed }) => {
  const data = useSitePage()
  const allPages = data.allSitePage.edges
  const allFirstLevelPage = allPages.filter(({ node }) => {
    return (
      node.context.baseLink === null &&
      node.context.slug === null &&
      node.context.slugTerm === null &&
      node.path !== "/"
    )
  })
  const allListingTaxoPages = allPages.filter(({ node }) => {
    return node.context.slugTerm !== null
  })
  const allActusPages = getIncomingAndPublishedData(
    data.allNodeActualites.edges
  )
  const allEventsPages = getIncomingAndPublishedData(
    data.allNodeEvenements.edges
  )
  const allAdressesPages = data.allNodeCarnetDAdresse.edges
  const allPagesPages = getIncomingAndPublishedData(data.allNodePage.edges)
  const allTeleformPages = data.allNodeTeleformulaires.edges
  const allDirectLink = data.allDirectLinkEntityDirectLinkEntity.edges
  return (
    <Layout message="Plan du site">
      <SEO
        description="Plan regroupant les différentes pages du site ainsi que les liens permettant d'y accéder"
        title="Plan du site"
      />
      {arianeDisplayed && <Ariane pageName="Plan du site" isListing={true} />}
      <div className={linkContainer}>
        <h1>Voici la liste des pages du site :</h1>
        <ul>
          <li>
            <StyledLink className={linksTitle} link="/">
              Accueil
            </StyledLink>
            <ul>
              <li>
                <StyledLink className={linksTitle} link="/actualites">
                  Liste des actualités
                </StyledLink>
                <ul>
                  {allActusPages.map(({ node }, index) => (
                    <li key={index}>
                      <StyledLink className={linksTitle} link={node.path.alias}>
                        {node.title}
                      </StyledLink>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <StyledLink className={linksTitle} link="/evenements">
                  Liste des évènements
                </StyledLink>
                <ul>
                  {allEventsPages.map(({ node }, index) => (
                    <li key={index}>
                      <StyledLink className={linksTitle} link={node.path.alias}>
                        {node.title}
                      </StyledLink>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <StyledLink className={linksTitle} link="/adresses">
                  Liste des adresses
                </StyledLink>
                <ul>
                  {allAdressesPages.map(({ node }, index) => (
                    <li key={index}>
                      <StyledLink className={linksTitle} link={node.path.alias}>
                        {node.title}
                      </StyledLink>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <StyledLink className={linksTitle} link="/pages">
                  Liste des pages
                </StyledLink>
                <ul>
                  {allPagesPages.map(({ node }, index) => (
                    <li key={index}>
                      <StyledLink className={linksTitle} link={node.path.alias}>
                        {node.title}
                      </StyledLink>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </li>
          {allFirstLevelPage.map(({ node }, index) => (
            <li key={index}>
              <StyledLink className={linksTitle} link={node.path}>
                {normalize(node.path)}
              </StyledLink>
            </li>
          ))}
          {allTeleformPages.map(({ node }, index) => (
            <li key={index}>
              <StyledLink className={linksTitle} link={node.path.alias}>
                {node.title}
              </StyledLink>
            </li>
          ))}
        </ul>
        <h3>Liste des pages par terme de taxonomie :</h3>
        <ul>
          {allListingTaxoPages.map(({ node }, index) => (
            <li key={index}>
              <StyledLink className={linksTitle} link={node.path}>
                {normalize(node.path)}
              </StyledLink>
            </li>
          ))}
        </ul>
        <h3>Liste des accès directs :</h3>
        <ul>
          {allDirectLink.map(({ node }, index) => (
            <li key={index}>
              <StyledExternalLink className={linksTitle} href={node.url.uri}>
                {node.name}
              </StyledExternalLink>
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  )
}

PlanSite.propTypes = {
  arianeDisplayed: PropTypes.bool,
}

export default PlanSite
